<template>
    <div>
        <el-form ref="formadd"  class="mrt20 flex" :label-position="labelPosition" label-width="100px" :model="addlist" :rules="rules">
                <div style="width: 45%;">
                    <el-form-item label="ID">
                        <el-input v-model="addlist.i_id" clearable disabled></el-input>
                    </el-form-item>
                    <el-form-item label="名称:" prop="vc_name">
                        <el-input v-model="addlist.vc_name" clearable :disabled="this.adddialogdata.title=='新增产品大类'||this.adddialogdata.title=='编辑产品大类'?false:true"></el-input>
                    </el-form-item>
                    <el-form-item label="别名:">
                        <el-input v-model="addlist.vc_nickname" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="英文名:">
                        <el-input v-model="addlist.vc_ename" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="产地:">
                        <el-input v-model="addlist.vc_cd" clearable :disabled="ifdisabled"></el-input>
                    </el-form-item>
                    <el-form-item label="厂家:">
                        <el-input v-model="addlist.vc_gykh" clearable :disabled="ifdisabled"></el-input>
                    </el-form-item>
                    <el-form-item label="图片">
                        <div  id="uploadPhoto">
                            <div style="height: 100px;width: 80px" v-model="addlist.file_path">
                                <input type="file" name="files" value="" id="uploadfile1"
                                       class="upload-input uploadfile1" @change="changepic">
                                <img src="@/assets/custom_pic.png" style="height:100% ;width: 100%" v-if="this.addlist.file_path.length==0">
                                <img :src="addlist.file_path" style="height:100% ;width: 100%" v-else>
                            </div>
                        </div>
                    </el-form-item>
                </div>

                <div style="width: 55%" class="mrl20">

                    <div class="flex">
                        <el-form-item label="包装规格:" class="w50">
                            <el-input  v-model="addlist.vc_bzstyle" clearable :disabled="ifdisabled"></el-input>
                        </el-form-item>
                        <el-form-item label="包装单位:" prop="vc_bzunit" class="w50">
                            <el-select v-model="addlist.vc_bzunit" clearable :disabled="ifdisabled">
                            <el-option
                                    v-for="item in bzdw"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.vc_name">
                            </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div  class="flex">
                        <el-form-item label="转换比率:" class="w50">
                            <el-input-number class="w100" :controls="false" v-model="addlist.f_bl" clearable :disabled="ifdisabled" :precision="6" ></el-input-number>
                        </el-form-item>
                        <el-form-item label="计量单位:" prop="vc_unit" class="w50">
                            <el-select v-model="addlist.vc_unit" clearable :disabled="ifdisabled">
                                <el-option
                                        v-for="item in dict"
                                        :key="item.i_id"
                                        :label="item.vc_name"
                                        :value="item.vc_name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div  class="flex">
                        <el-form-item label="单件净重:" prop="f_weight" class="w50">
                            <el-input-number class="w100" :controls="false" v-model.number="addlist.f_weight" clearable :disabled="ifdisabled" :precision="4" ></el-input-number>
                        </el-form-item>
                        <el-form-item label="件重单位:" prop="vc_djunit" class="w50">
                            <el-select v-model="addlist.vc_djunit" clearable :disabled="ifdisabled">
                                <el-option
                                        v-for="item in jzdw"
                                        :key="item.i_id"
                                        :label="item.vc_name"
                                        :value="item.vc_name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div  class="flex">
                        <el-form-item label="产品属性:" prop="i_flag" class="w50">
                            <el-select  v-model="addlist.i_flag" @change="flagChange">
                                <el-option
                                        v-for="item in flagList"
                                        :key="item.i_id"
                                        :label="item.vc_name"
                                        :value="item.i_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="货物性质:" prop="vc_type" class="w50">
                            <el-select  v-model="addlist.vc_type" clearable :disabled="ifdisabled">
                                <el-option
                                        v-for="item in things"
                                        :key="item.i_id"
                                        :label="item.vc_name"
                                        :value="item.vc_name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div  class="flex">
                        <el-form-item label="散水/非散水:" class="w50">
                            <template class="flex">
                                <el-radio v-model="addlist.i_type" :label=1 :disabled="ifdisabled">非散水</el-radio>
                                <el-radio v-model="addlist.i_type" :label=0 :disabled="ifdisabled">散水</el-radio>
                            </template>
                        </el-form-item>


                        <el-form-item label="是否传电商:" class="w50">
                            <template class="flex">
                                <el-radio v-model="addlist.isec" :label=1 :disabled="ifdisabled">是</el-radio>
                                <el-radio v-model="addlist.isec" :label=0 :disabled="ifdisabled">否</el-radio>
                            </template>
                        </el-form-item>
                    </div>
                    <div  class="flex">
                        <el-form-item label="是否计件:" class="w50">
                            <template class="flex">
                                <el-radio v-model="addlist.isjian" :label=1 :disabled="ifdisabled">是</el-radio>
                                <el-radio v-model="addlist.isjian" :label=0 :disabled="ifdisabled">否</el-radio>
                            </template>
                        </el-form-item>

                        <el-form-item label="是否用包装物:"class="w50">
                            <template class="flex">
                                <el-radio v-model="addlist.isusepack" :label=1 :disabled="ifdisabled">是</el-radio>
                                <el-radio v-model="addlist.isusepack" :label=0 :disabled="ifdisabled">否</el-radio>
                            </template>
                        </el-form-item>
                    </div>
<!--                    <div  class="flex">-->

                        <el-form-item label="成本核算:" >
                            <template class="flex">
                                <el-radio v-model="addlist.i_pzid_js" :label=0 :disabled="ifdisabled">大类ID</el-radio>
                                <el-radio v-model="addlist.i_pzid_js" :label=1 :disabled="ifdisabled">规格ID</el-radio>
                            </template>
                        </el-form-item>
                        <el-form-item label="库存核算:" >
                            <template class="flex">
                                <el-radio v-model="addlist.i_pzid_kcjs" :label='0' :disabled="ifdisabled">大类ID</el-radio>
                                <el-radio v-model="addlist.i_pzid_kcjs" :label='1' :disabled="ifdisabled">规格ID</el-radio>
                            </template>
                        </el-form-item>
<!--                    </div>-->



                </div>
            <!--<el-form-item label="信用代码:">-->
            <!--  <el-input v-model="addlist.vc_creditcode"></el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="附件路径:">-->
            <!--  <el-input v-model="addlist.file_path"></el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="父id:">-->
            <!--  <el-input v-model="addlist.pid" ></el-input>-->
            <!--</el-form-item>-->
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click="resetFormson()">取 消</el-button>
          <el-button type="primary" @click="saveadd" :disabled="disabled">保存</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from  "./api";
    import {filerequest_url} from './api';
    import {mapActions} from "vuex";
    import  {file_url} from '@/utils/baseUrl'
    export default {
        name:"adddialog",

        props: {
            adddialogdata: {
                type: Object,
                required: true,
            }
        },

        mounted(){
            this.file_url=file_url
            this.before = JSON.parse(JSON.stringify(this.adddialogdata));

            this.start();

            this. getDict();
            this.thingsdata();
            this.bzdwData();
            this.jzdwData();
            this.listFlags()

        },

        data(){
            return{
                formadd:{},
                before:{},
                addlist:{
                    isjian: "",
                    i_type:"",
                    isec: "",
                    file_path:"",
                    isusepack:0,
                    i_pzid_js:0,
                    i_pzid_kcjs:0,
                },
                subscribeData:[],
                adddialogVisible:false,
                subscribedialogVisible:false,
                editdialogVisible:false,
                labelPosition: 'right',
                isSee:true,
                rules: {
                    vc_name: [
                        { required: true, message: '请输入商品名称', trigger: 'blur' },
                    ],
                    f_weight:[
                        { required: true, message: '净重必须为数字值' ,trigger: 'blur'}
                    ],

                    vc_unit:[
                        { required: true, message: '请选择计量单位', trigger: 'change' }
                    ],
                    f_bl:[
                        { required: true, message: '请输入转换比率', trigger: 'change' }
                    ],
                    vc_type:[
                        { required: true, message: '请选择货物性质', trigger: 'change' }
                    ],
                    i_flag:[
                        { required: true, message: '请选择产品属性', trigger: 'change' }
                    ],
                },
                product:"",
                location:"",
                company:"",
                begintime:"",
                endtime:"",
                dict:[],
                jzdw:[],
                bzdw:[],
                value1:"",
                things:[],
                value2:"",
                disabled:false,
                ifdisabled:false,
                //cv 上传图片的data
                idNum: 1,
                fileName: "",
                fileType: "",
                fileUrl: "",
                imgLength: 0,
                imgList: [],
                didNum: 1,
                file_url:'',
                flagList:[]
            }
        },


        methods: {
            ...mapActions(["getCurrentMenuId"]),

            //初始
            start(){
                this.addlist=this.before.value;
                this.addlist.i_id=this.before.i_id;
                this.addlist.pid=this.before.pid;
                if (this.adddialogdata.title=="新增产品大类"||this.adddialogdata.title=="编辑产品大类"){
                    this.ifdisabled=true;
                    this.rules={};
                    //console.log(this.ifdisabled,"000000000000")
                }else if (this.adddialogdata.title=="新增规格"||this.adddialogdata.title=="编辑规格"){
                    this.ifdisabled=false;
                }

                //this.addlist.file_path=this.addlist.file_path==''?require('@/assets/custom_pic.png'):this.addlist.file_path;
            },

            //单位接口(计量单位)
            async getDict(){
                let param={
                    token:"",
                    i_uid:"",
                    app:"",
                    version:"",
                    data_type:2
                };
                let res=await API.getDict(param);
                if (res.code==1){
                    //console.log(res,"getDict");
                    this.dict=res.data;
                    //console.log(this.dict,"this.dict")
                }
            },
            //单位接口(货物性质)
            async thingsdata(){
                let param={
                    token:"",
                    i_uid:"",
                    app:"",
                    version:"",
                    data_type:1,
                }
                let res=await API.getDict(param);
                if (res.code==1){
                    //console.log(res,"thingsdatagetDict");
                    this.things=res.data;
                    //console.log(this.things,"this.things")
                }
            },
            async bzdwData(){
                let param={
                    token:"",
                    i_uid:"",
                    app:"",
                    version:"",
                    data_type:3,
                }
                let res=await API.getDict(param);
                if (res.code==1){
                    //console.log(res,"thingsdatagetDict");
                    this.bzdw=res.data;
                    //console.log(this.things,"this.things")
                }
            },
            async listFlags(){
                let param={
                }
                let res=await API.listFlags(param);
                if (res.code==1){
                    this.flagList=res.data;
                    if(this.adddialogdata.title=="新增产品大类")this.addlist.i_flag=2
                }
            },
            flagChange(val){
                console.log(val,'val')
                this.addlist.i_flag=val
                this.$forceUpdate()
            },
            async jzdwData(){
                let param={
                    token:"",
                    i_uid:"",
                    app:"",
                    version:"",
                    data_type:4,
                }
                let res=await API.getDict(param);
                if (res.code==1){
                    //console.log(res,"thingsdatagetDict");
                    this.jzdw=res.data;
                    this.addlist.vc_djunit= this.jzdw[0].vc_name;
                    //console.log(this.things,"this.things")
                }
            },
            //新增的时候点击取消清空掉里面已经上传的图片信息
            resetFormson(){
                this.addlist={};
                this.$emit('cancelEdit', this.addlist)
                //console.log(this.addlist,"this.addlist")
            },

            //新增里保存按钮
            saveadd() {
                if (this.adddialogdata.title!="新增产品大类"&&this.adddialogdata.title!="编辑产品大类"){
                    if(this.addlist.vc_name==''||this.addlist.vc_name==undefined){
                        this.$message.error('请输入商品名称');
                        return
                    }

                    if(this.addlist.f_weight===''||this.addlist.f_weight==undefined){
                        this.$message.error('请输入单件净重');
                        return
                    }
                    if(this.addlist.vc_unit==''||this.addlist.vc_unit==undefined){
                        this.$message.error('请选择计量单位');
                        return
                    }
                    if(this.addlist.vc_type==''||this.addlist.vc_type==undefined){
                        this.$message.error('请选择货物性质');
                        return
                    }
                    if(this.addlist.f_bl===''||this.addlist.f_bl==undefined){
                        this.$message.error('请输入转换比率');
                        return
                    }

                }
                if(this.addlist.i_flag===undefined){
                    this.$message.error('请选择产品属性');
                    return
                }

                this.saveMDMessage();

            },
            saveaddNew() {
                //console.log(this.addlist,"this.addlist");
                /*if (this.adddialogdata.title=="新增产品大类"||this.adddialogdata.title=="新增规格"){
                    let pagesize=1;
                    this.$emit('getMDSysMessage',null,pagesize);
                }else{
                    let pagesize=this.before.pageSize;
                    this.$emit('getMDSysMessage',null,pagesize);
                }*/
                let pageSize=this.before.pageSize;
                this.$emit('getMDSysMessage',pageSize);
                //this.$emit('getMDSysMessage');
                this.resetFormson();
            },
            ///新增接口
            async saveMDMessage() {
                let param = {
                    pid:this.adddialogdata.pid,
                    i_id:this.adddialogdata.i_id,
                    token: "",
                    i_uid: "",
                    app: "",
                    version: "",
                    data_type:"product",
                    object: this.addlist,
                };
                let res = await API.saveMDSysMessage(param);
                if (res.code == 1) {
                    this.saveaddNew();
                    this.disabled=true;
                    this.$message.success(res.message);
                    //console.log(res, "saveMDMessage");
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },

            //新增-上传图片
            async changepic(value) {
                // let companyid =this.formDate.gsname;
                //let that = this;
                let i = 0;
                let $files = value.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": false
                };
                let result = list[type];
                if (($files && result == false) || ($files && result == undefined)) {
                    this.$message.error('请上传格式正确的文件');
                    return;
                }
                if ($files) {
                    this.fileName = $files.name;
                    this.fileType = $files.type;
                    this.fileUrl = window.URL.createObjectURL(value.target.files[0]);
                } else {
                    this.fileName = "";
                    this.fileType = "";
                    this.fileUrl = "";
                }
                if (this.fileName) {
                    var fileId = 'uploadfile' + this.idNum;
                    var param = {
                        "file": fileId,
                        "fileName": this.fileName,
                        "vc_app": "ht",
                        "IDtype": "",
                        "type": 1,
                        "style": "product",
                        "files": $files,
                        "token": sessionStorage.getItem("token"),
                        "app": "dsmanage",
                        "version": "1.0",
                        "i_uid": sessionStorage.getItem("userid"),
                    };

                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }

                    let res = await fetch(filerequest_url, {
                        method: "post",
                        body: FD
                    }).then(res => res.text());

                    res = JSON.parse(res);
                    let data = res.data[0];
                    if (res.code == 1) {
                        this.addlist.i_fileid=data.i_id;
                        //console.log(this.addlist.file_id, "this.addlist.file_id");
                        this.addlist.name = data.filename;
                        //console.log(this.addlist.name, "this.addlist.name");
                        this.addlist.file_path=this.file_url+ data.vc_path;
                        //console.log(this.addlist.file_path,"this.addlist.file_path");
                        //console.log(this.addlist,"3333333333");
                        this.addlist.width=data.width;
                        this.addlist.height=data.height;
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },

        }
    }

</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        justify-content: space-around;

    }
.inputW{
    width: calc(100% - 100px);
}
    .mrl20{
        margin-left: 20px;
    }

    .mrr50{
        margin-right:100px;
    }

    .cl{
        clear: both;
    }

    .fl{
        float: left;
    }

    .fr{
        float: right;
    }
.w50{
    width: 50%;
}
.w100{
    width: 100%;
}
    .upload-input {
        position: absolute;
        opacity: 0;
        width: 80px;
        height: 100px;
    }

    /deep/{
        /*.upload-input[data-v-a4d5ba82]{*/
        /*    right:160px;*/
        /*    bottom: 10px;*/
        /*}*/
    }
    .el-radio{
        margin-right: 12px;
    }
    .el-radio:last-child{
        margin-right: 0;
    }
</style>